<template>
  <div>
    <div class="checkbox-list">
      <div
        v-for="(item, itemIndex) in proxyArray"
        :key="item.id"
        class="checkbox-item"
      >
        <div
          class="program-selector"
          @click="item.isSelected = !item.isSelected"
        >
          <p class="program-title">{{ item.title }}</p>
          <ToggleSwitch v-model="item.isSelected" />
        </div>
        <div class="checkup-stats">
          <div
            v-for="(group, groupId) in groupsItemsCount[itemIndex]"
            :key="groupId"
            class="checkup-stats__item"
            @click="
              $emit(
                'openProgramGroupsInfo',
                'open',
                `${group.length} ${getPluralTitle(groupId, group.length)}`,
                group
              )
            "
          >
            {{ group.length }} {{ getPluralTitle(groupId, group.length) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue'
import ToggleSwitch from './ToggleSwitch.vue'
import { pluralize } from '@/views/programs/checkup/utils/pluralize.js'

export default {
  name: 'RegularCheckboxList',
  emits: ['updateSelectedPrograms', 'emitSelectedCheckbox'],
  components: { ToggleSwitch },
  props: {
    modelValue: {
      type: [Array || null],
      default: null,
      required: true
    },
    programsSetup: {
      type: [Array || null],
      default: null,
      required: true
    }
  },
  setup (props, { emit }) {
    const proxyArray = ref(props.modelValue)

    watch(
      proxyArray,
      () => {
        emit('updateSelectedPrograms', proxyArray.value)
      },
      { deep: true }
    )

    const groupsItemsCount = computed(() => {
      return proxyArray.value.map((checkup) => {
        return checkup.items.reduce((acc, item) => {
          if (!acc[item.group_id]) {
            acc[item.group_id] = []
          }
          acc[item.group_id].push(item)
          return acc
        }, {})
      })
    })

    function getPluralTitle (groupId, count) {
      const group = props.programsSetup.group_id.find(
        (group) => group.value === +groupId
      )
      return group.plural[pluralize(count)]
    }

    return {
      proxyArray,
      groupsItemsCount,
      getPluralTitle
    }
  }
}
</script>

<style scoped>
.checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.checkbox-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 16px;
}
.checkbox-item:not(:last-child) {
  border-bottom: 1px solid #e1e8f4;
}
.checkup-stats {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.checkup-stats__item {
  display: grid;
  place-content: center;
  background: #fff;
  border-radius: 100px;
  font-weight: 400;
  font-style: Regular;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  font-size: 10px;
  height: 28px;
  border: 1px solid #7f8da9;
  padding: 0 16px;
  color: #002856;
  cursor: pointer;
}

.check-up__image {
  width: 100%;
  max-height: 130px;
  object-fit: cover;
  border-radius: 4px;
}

.program-selector {
  display: flex;
  justify-content: space-between;
}

.program-title {
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0%;
  color: #002856;
  cursor: pointer;
}
</style>
